import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

function AuthCallback() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { setToken } = useAuth()

  useEffect(() => {
    const token = searchParams.get('token')
    const refreshToken = searchParams.get('refreshToken')
    const isNewUser = searchParams.get('isNewUser') === 'true'

    if (token) {
      // Store the token. A brand-new Google/Facebook user finishes their details first; anyone else
      // goes to the dashboard (ProfileGate catches an incomplete profile on a later visit).
      localStorage.setItem('token', token)
      if (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken)
      }
      setToken(token)
      const destination = isNewUser ? '/complete-profile' : '/dashboard'
      navigate(destination, { replace: true })
    } else {
      // No token - login failed
      navigate('/login?error=oauth_failed', { replace: true })
    }
  }, [searchParams, navigate, setToken])

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-primary)',
      '--bg-primary': '#F7FAF7',
      '--forest-green': '#1B5E20',
      '--border': '#E2E8F0',
      '--text-secondary': '#4A5568'
    } as React.CSSProperties}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '4px solid var(--border)',
          borderTop: '4px solid var(--forest-green)',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 1rem'
        }} />
        <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem' }}>
          Completing sign in...
        </p>

        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  )
}

export default AuthCallback
